const UtagData = {
  // All pages
  general: {
    page_business_line: "rbwm",
    page_customer_group: "general",
    page_security_level: 30,
    site_section: "pws",
    page_category: "application",
    page_subcategory: "retail business banking",
    product_category: "retail business banking",
    product_subcategory: "fusion current account",
    funnel_name: "retail business banking onboarding"
  },
  // Mobile Validation
  logon: {
    page_type: "verification",
    page_name: "pws:application:retail business banking:mobile validation",
    funnel_step_name: "mobile validation",
    event_category: "verification",
    event_action: "logon",
    event_content: "otp"
  },
  // Application Overview
  accountOpeningSteps: {
    page_security_level: 30,
    page_type: "application",
    page_name: "pws:application:retail business banking:overview",
    funnel_step_name: "application pre-check - overview",
    "event_category": "application",
    "event_action": "start"
  },
  // Applicant Information
  applicantInformation: {
    page_type: "application",
    page_name: "pws:application:retail business banking:applicant information",
    funnel_step_name: "application pre-check - applicant information"
  },
  // Company Registration
  companyRegistration: {
    page_type: "application",
    page_name: "pws:application:retail business banking:company registration",
    funnel_step_name: "application pre-check - company registration"
  },
  // additional Information 1
  basicInfo: {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:additional information 1",
    funnel_step_name: "application pre-check - additional information 1"
  },
  // additional Information 2
  accountQuestion: {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:additional information 2",
    funnel_step_name: "application pre-check - additional information 2"
  },
  // Review and Confirm
  previewQuestion: {
    page_type: "application",
    page_name: "pws:application:retail business banking:review and confirm",
    funnel_step_name: "application pre-check - review and confirm"
  },
  // Decline
  confirmPQ: {
    page_type: "application",
    page_name: "pws:application:retail business banking:decline",

    funnel_step_name: "application pre-check - decline"
  },
  // Application Dashboard - start
  dashboard: {
    page_type: "application",
    page_name: "pws:application:retail business banking:dashboard",
    funnel_step: 1,
    funnel_step_name: "dashboard"
  },
  // Company Information
  "aoform/Q003-001": {
    page_type: "application",
    page_name: "pws:application:retail business banking:company information",

    funnel_step: 2,
    funnel_step_name: "company information"
  },
  // Business Information
  "aoform/Q003-002": {
    page_type: "application",
    page_name: "pws:application:retail business banking:business information",

    funnel_step: 2,
    funnel_step_name: "business information"
  },
  // Account Information
  "aoform/Q003-003": {
    page_type: "application",
    page_name: "pws:application:retail business banking:account information",

    funnel_step: 2,
    funnel_step_name: "account information"
  },
  // Financial Information
  "aoform/Q003-004": {
    page_type: "application",
    page_name: "pws:application:retail business banking:financial information",

    funnel_step: 2,
    funnel_step_name: "financial information"
  },
  // Taxation Information
  "aoform/Q003-005": {
    page_type: "application",
    page_name: "pws:application:retail business banking:taxation information",

    funnel_step: 2,
    funnel_step_name: "taxation information"
  },
  // Contact Information
  "aoform/Q003-006": {
    page_type: "application",
    page_name: "pws:application:retail business banking:contact information",

    funnel_step: 2,
    funnel_step_name: "contact information"
  },
  // Connected Parties
  "aoform/Q003-007": {
    page_type: "application",
    page_name: "pws:application:retail business banking:connected parties",

    funnel_step: "2",
    funnel_step_name: "connected parties"
  },
  // Application Dashboard - Upload Documents
  aoFormReview: {
    page_type: "application",
    page_name: "pws:application:retail business banking:dashboard",

    funnel_step: 1,
    funnel_step_name: "application dashboard"
  },
  // Business License Q004-001
  "file_upload_info/MenuBusinessDocFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:business license containing unified social credit code",

    funnel_step: 3,
    funnel_step_name: "upload documents - business license containing unified social credit code"
  },

  "file_upload_info/MenuBusinessSoleTraderDocFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:business license",

    funnel_step: 3,
    funnel_step_name: "upload documents - business license"
  },

  "file_upload_info/MenuBasicSavAccOpeCertFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:basic account opening certificate",

    funnel_step: 3,
    funnel_step_name: "upload documents - basic account opening certificate"
  },

  "file_upload_info/MenuInsCreCodeCertFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:institution credit code certificate",

    funnel_step: 3,
    funnel_step_name: "upload documents - institution credit code certificate"
  },

  "file_upload_info/MenuRegFillRecForInvFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:foreign-funded enterprise approval certificate (or foreign-funded enterprise filing receipt, if applicable) / filing receipt for foreign-funded enterprises establishment",

    funnel_step: 3,
    funnel_step_name: "upload documents - foreign-funded enterprise approval certificate (or foreign-funded enterprise filing receipt, if applicable) / filing receipt for foreign-funded enterprises establishment"
  },

  "file_upload_info/MenuArtAssFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:memorandum/articles of association and amending supplements",

    funnel_step: 3,
    funnel_step_name: "upload documents - memorandum/articles of association and amending supplements"
  },

  "file_upload_info/PerIdenDoc": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:personal identification document",

    funnel_step: 3,
    funnel_step_name: "upload documents - personal identification document"
  },

  "file_upload_info/MenuPowerAttIDFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:power of attorney's id",

    funnel_step: 3,
    funnel_step_name: "upload documents - power of attorney's id"
  },

  "file_upload_info/MenuAddProofFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:proof of residential address",

    funnel_step: 3,
    funnel_step_name: "upload documents - proof of residential address"
  },

  "file_upload_info/MenuPermAddProofFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:proof of permanent address",

    funnel_step: 3,
    funnel_step_name: "upload documents - proof of permanent address"
  },

  "file_upload_info/MenuOrgChartFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:ownership structure chart",

    funnel_step: 3,
    funnel_step_name: "upload documents - ownership structure chart"
  },

  "file_upload_info/ProofSourceFundFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:bank statement",

    funnel_step: 3,
    funnel_step_name: "upload documents - bank statement"
  },

  "file_upload_info/ProofSourceWealthFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:business proof",

    funnel_step: 3,
    funnel_step_name: "upload documents - business proof"
  },

  "file_upload_info/MenuManComBRFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:board of directors resolutions",

    funnel_step: 3,
    funnel_step_name: "upload documents - board of directors resolutions"
  },

  "file_upload_info/MenuPowerAttLetFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:power of attorney for account opening(if any)",

    funnel_step: 3,
    funnel_step_name: "upload documents - power of attorney for account opening(if any)"
  },

  "file_upload_info/MandAccLocalEntNoBoaDirFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:mandate for accounts of a local entity with no board of directors",

    funnel_step: 3,
    funnel_step_name: "upload documents - mandate for accounts of a local entity with no board of directors"
  },

  "file_upload_info/ListKeyControlFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:list of key controllers",

    funnel_step: 3,
    funnel_step_name: "upload documents - list of key controllers"
  },

  "file_upload_info/DirecterListFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:director list",

    funnel_step: 3,
    funnel_step_name: "upload documents - director list"
  },

  "file_upload_info/QuestionnaireFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:questionnaire",

    funnel_step: 3,
    funnel_step_name: "upload documents - questionnaire"
  },

  "file_upload_info/DeclaStaAccUSTaxPrinFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:declaration of status according to us tax principles(Iindividuals)",

    funnel_step: 3,
    funnel_step_name: "upload documents - declaration of status according to us tax principles(Iindividuals)"
  },

  "file_upload_info/ComReportStandIndSelfCertFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:upload documents:common reporting standard (crs) individual self certification",

    funnel_step: 3,
    funnel_step_name: "upload documents - common reporting standard (crs) individual self certification"
  },

  "file_upload_info/UBOBankStateFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:the ubo's bank statement ( within 3 months)",

    funnel_step: 3,
    funnel_step_name: "upload documents - the ubo's bank statement ( within 3 months)"
  },

  "file_upload_info/BusiPlanOrStateIssFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:business plan or new start-up company declaration",

    funnel_step: 3,
    funnel_step_name: "upload documents - business plan or new start-up company declaration"
  },

  "file_upload_info/MenuFillRepTraBusFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:e-delivery of statements and sdvices service application form (if applicable)",

    funnel_step: 3,
    funnel_step_name: "upload documents - e-delivery of statements and sdvices service application form (if applicable)"
  },

  "file_upload_info/MenuOtherDocFile": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:other documents",

    funnel_step: 3,
    funnel_step_name: "upload documents - other documents"
  },
  // Offshore start
  "file_upload_info/InsCreCodeCertOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:institution credit code certificate(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - institution credit code certificate(offshore)"
  },

  "file_upload_info/ArtAssoOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:memorandum/articles of association(m&a/aoa) and amending supplements(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - memorandum/articles of association(m&a/aoa) and amending supplements(offshore)"
  },

  "file_upload_info/BusiRegCertOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:business registration certificate(brc)(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - business registration certificate(brc)(offshore)"
  },

  "file_upload_info/CertIncorpOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:certificate of incorporation(ci)(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - certificate of incorporation(ci)(offshore)"
  },

  "file_upload_info/NncNarReportOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:nnc/nar1 report",

    funnel_step: 3,
    funnel_step_name: "upload documents - nnc/nar1 report"
  },

  "file_upload_info/SpeOrgCodeOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:special entity code certificate(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - special entity code certificate(offshore)"
  },

  "file_upload_info/PerIdenDocOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:	personal identification document(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents -	personal identification document(offshore)"
  },

  "file_upload_info/AddProofOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:proof of residential address(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - proof of residential address(offshore)"
  },

  "file_upload_info/MenuPermAddProofFileOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:	proof of permanent address(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents -	proof of permanent address(offshore)"
  },

  "file_upload_info/OwnStrucChartOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:ownership structure chart(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - ownership structure chart(offshore)"
  },

  "file_upload_info/ProofSourceFundFileOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:bank statement(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - bank statement(offshore)"
  },

  "file_upload_info/ProofSourceWealthFileOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:business proof(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - business proof(offshore)"
  },

  "file_upload_info/ManAccLimitComOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:mandate for accounts of a limited company(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - mandate for accounts of a limited company(offshore)"
  },

  "file_upload_info/DirctorDeclationOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:	director declaration(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents -	director declaration(offshore)"
  },

  "file_upload_info/ListKeyControlFileOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:list of key controllers(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - list of key controllers(offshore)"
  },

  "file_upload_info/NonTrustAgenConFileOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:non-trust declaration(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - non-trust declaration(offshore)"
  },

  "file_upload_info/MenuOtherDocFileOff": {
    page_type: "application",
    page_name:
      "pws:application:retail business banking:other documents(offshore)",

    funnel_step: 3,
    funnel_step_name: "upload documents - other documents(offshore)"
  },

  // Terms and Conditions
  agreement: {
    page_type: "application",
    page_name: "pws:application:retail business banking:terms and conditions",

    funnel_step: 4,
    funnel_step_name: "terms and conditions"
  },
  //Application - Submit
  appointment: {
    page_type: "application",
    page_name: "pws:application:retail business banking:submission successful",
    funnel_step: 5,
    funnel_step_name: "submission successful",
    event_category: "application",
    event_action: "submit",
    application_id: window.sessionStorage.getItem("rbbInfo") && JSON.parse(window.sessionStorage.getItem("rbbInfo")).applicationId
  },
  //Edit Application
  appointment2: {
    page_type: "application",
    page_name: "pws:application:retail business banking:edit application",
    funnel_step_name: "edit application"
  },
  // Help
  help: {
    page_type: "application",
    page_name: "pws:application:retail business banking:help",
    funnel_step_name: "help"
  }
};
const common = {
  event_category: 'content',
  event_action: 'button click'
}
export const EventTag = {
  logon: {
    ...common,
    event_content: 'resend sms'
  },
  DashboardReview: {
    ...common,
    event_content: 'review my application'
  },
  DashboardComplete: {
    ...common,
    event_content: 'complete review'
  },
  file_upload_info: {
    ...common,
    event_action: 'onsite',
    event_content: 'view file'
  },
  appointment: {
    ...common,
    event_content: 'submit reference code'
  },
  help: {
    ...common,
    event_content: 'contact us: 400-820-1177'
  },
  helpDropdown: (text) => ({
    ...common,
    event_action: 'accordian',
    event_content: text
  })
};

export default UtagData;



// WEBPACK FOOTER //
// ./src/config/tagging.js